import classNames from 'classnames';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { useLoginOptionsPresenter } from './LoginOptions.presenter';
import styles from './LoginOptions.styles.m.css';

interface ILoginOptionsProps {
  className?: string;
}

export const LoginOptions: FC<ILoginOptionsProps> = (props) => {
  const { t } = useTranslation();
  const presenter = useLoginOptionsPresenter();

  const containerClassName = classNames(styles.container, props.className);

  if (!presenter.options.length) {
    return null;
  }

  return (
    <div className={containerClassName}>
      <div className={styles.divider}>
        <span className={styles.dividerText}>{t('auth_or_divider')}</span>
      </div>
      <div className={styles.buttons}>
        {presenter.options.map((option) => (
          <Button
            key={option.key}
            onClick={option.onClick}
            size="20"
            theme="fixed-icon"
          >
            {option.title}
          </Button>
        ))}
      </div>
    </div>
  );
};
